export enum OrgChartFilter {
  Roles = 'roles',
  HappinessReaction = 'happiness.reaction',
  Name = 'name',
  Happiness = 'happiness',
}
